import { Modal } from '@/components/modal'

type ConfirmDialogProps = {
  open: boolean
  title: string
  body: string
  confirmLabel?: string
  danger?: boolean
  busy?: boolean
  onConfirm: () => void
  onClose: () => void
}

export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel = 'Confirmer',
  danger,
  busy,
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      title={title}
      onClose={busy ? () => undefined : onClose}
      footer={
        <>
          <button
            type="button"
            disabled={busy}
            onClick={onClose}
            className="kicker rounded-pilule border border-bordure-admin px-3.5 py-2 text-encre-admin"
          >
            Annuler
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onConfirm}
            className={`kicker rounded-pilule px-3.5 py-2 text-creme ${
              danger ? 'bg-rouge' : 'bg-encre-admin'
            }`}
          >
            {busy ? '…' : confirmLabel}
          </button>
        </>
      }
    >
      <p className="text-sm text-second-admin">{body}</p>
    </Modal>
  )
}
